/**
 * Welle-9 — Mengenfeld an der Produktkarte (Übersichts- und Suchseiten)
 *
 * Das Feld selbst ist reines HTML im Warenkorb-Formular der Karte; Shopify
 * uebernimmt `quantity` beim Absenden ohne Zutun. Diese Datei kuemmert sich
 * nur um die Bedienung drumherum:
 *
 *  - Klicks im Feld duerfen nicht den Kartenlink ausloesen (die Karte ist
 *    ganzflaechig verlinkt) — sonst landet man auf der Produktseite,
 *    sobald man die Menge antippt.
 *  - Enter im Feld legt direkt in den Warenkorb, statt nichts zu tun.
 *  - Nach dem Hinzufuegen springt die Menge zurueck auf 1. Sonst legt der
 *    naechste Klick unbemerkt nochmal dieselbe Menge nach.
 *  - Eingaben werden auf gueltige Werte begrenzt (mindestens 1, hoechstens
 *    der vorhandene Bestand, keine Buchstaben, keine Kommazahlen).
 */
(function () {
  'use strict';

  var FELD = '[data-welle9-menge]';

  function begrenzen(feld) {
    var wert = parseInt(feld.value, 10);
    if (isNaN(wert) || wert < 1) wert = 1;

    var max = parseInt(feld.getAttribute('max'), 10);
    if (!isNaN(max) && max > 0 && wert > max) {
      wert = max;
      // Kurz markieren, damit die stille Korrektur nicht verwirrt
      feld.setAttribute('data-begrenzt', 'true');
      setTimeout(function () { feld.removeAttribute('data-begrenzt'); }, 1200);
    }

    feld.value = wert;
    feld.setAttribute('data-abweichend', wert > 1 ? 'true' : 'false');
    return wert;
  }

  function aufFeldReagieren(feld) {
    if (feld.dataset.welle9Gebunden === '1') return;
    feld.dataset.welle9Gebunden = '1';

    // Die Karte ist ganzflaechig verlinkt — ohne das hier oeffnet jeder
    // Tipp ins Feld die Produktseite.
    ['click', 'mousedown', 'touchstart'].forEach(function (typ) {
      feld.addEventListener(typ, function (e) { e.stopPropagation(); }, { passive: true });
    });

    // Beim Hineinklicken die vorhandene Zahl markieren, damit man die neue
    // Menge direkt tippen kann, statt erst die 1 wegloeschen zu muessen.
    // Hinweis: setSelectionRange wirft bei type="number" eine Ausnahme,
    // select() ist hier der einzige Weg. Das setTimeout ist noetig, weil
    // Safari und iOS eine Markierung direkt im focus-Handler wieder
    // verwerfen.
    feld.addEventListener('focus', function () {
      setTimeout(function () {
        try { feld.select(); } catch (e) { /* aeltere Browser: dann eben nicht */ }
      }, 0);
    });

    feld.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      // Im Formular wuerde Enter den ersten Submit-Button ausloesen; das ist
      // hier der richtige, wir machen es aber explizit und schliessen die
      // Tastatur auf dem Handy.
      e.preventDefault();
      begrenzen(feld);
      feld.blur();
      var formular = feld.closest('form');
      var knopf = formular && formular.querySelector('[type="submit"]');
      if (knopf) knopf.click();
    });

    feld.addEventListener('input', function () {
      // Waehrend des Tippens nur offensichtlichen Unsinn abfangen, damit man
      // eine 12 eingeben kann, ohne dass nach der 1 korrigiert wird.
      feld.value = feld.value.replace(/[^\d]/g, '');
      // Hervorhebung sofort mitziehen: die Rueckmeldung "hier steht nicht 1"
      // kommt sonst erst beim Verlassen des Feldes, also womoeglich nie —
      // viele klicken direkt vom Feld auf das Plus.
      feld.setAttribute('data-abweichend', parseInt(feld.value, 10) > 1 ? 'true' : 'false');
    });

    feld.addEventListener('change', function () { begrenzen(feld); });
    feld.addEventListener('blur', function () { begrenzen(feld); });
  }

  function alleFelderBinden() {
    document.querySelectorAll(FELD).forEach(aufFeldReagieren);
  }

  function zuruecksetzen() {
    document.querySelectorAll(FELD).forEach(function (feld) {
      feld.value = 1;
      feld.setAttribute('data-abweichend', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    alleFelderBinden();

    // Nach jedem Warenkorb-Update zuruecksetzen. Das Ereignis feuert auch,
    // wenn andere Theme-Teile etwas hinzufuegen — das ist gewollt, danach
    // steht ueberall wieder die 1.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, zuruecksetzen);
    }
  });

  // Nachgeladene Karten (Filter, "Mehr laden", Section-Rendering) mitnehmen.
  if ('MutationObserver' in window) {
    new MutationObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (eintraege[i].addedNodes.length) { alleFelderBinden(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/**
 * Welle-9 — Produktbeschreibung auf dem Handy anreissen
 *
 * Der Knopf ist im Markup `hidden` und wird nur eingeblendet, wenn der Text
 * tatsaechlich abgeschnitten ist. Zwei Gruende:
 *  - Bei kurzen Beschreibungen waere ein "Mehr anzeigen" ohne Mehr sinnlos.
 *  - Am Rechner greift die Begrenzung gar nicht, dort bleibt alles wie bisher.
 */
(function () {
  'use strict';

  function einrichten() {
    var text = document.querySelector('[data-welle9-anriss]');
    var knopf = document.querySelector('[data-welle9-mehr]');
    if (!text || !knopf) return;

    // Ist ueberhaupt etwas abgeschnitten? scrollHeight vergleicht den
    // vollen Inhalt mit der sichtbaren Hoehe.
    var abgeschnitten = text.scrollHeight > text.clientHeight + 4;
    if (!abgeschnitten) {
      knopf.hidden = true;
      return;
    }

    knopf.hidden = false;
    knopf.setAttribute('aria-expanded', 'false');

    knopf.addEventListener('click', function () {
      var offen = text.classList.toggle('welle9-offen');
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      knopf.querySelector('.welle9-mehr-text__label').textContent = offen ? 'Weniger anzeigen' : 'Mehr anzeigen';
      if (!offen) {
        // Beim Zuklappen zurueck an den Textanfang, sonst steht man
        // ploetzlich mitten im Nichts weiter unten.
        text.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
  // Nach Drehen des Geraets neu bewerten
  window.addEventListener('resize', function () {
    var text = document.querySelector('[data-welle9-anriss]');
    var knopf = document.querySelector('[data-welle9-mehr]');
    if (!text || !knopf || text.classList.contains('welle9-offen')) return;
    knopf.hidden = !(text.scrollHeight > text.clientHeight + 4);
  });
})();

/**
 * Welle-9 — Footer-Linkgruppen auf dem Handy zusammenfalten
 *
 * Der Footer ist mobil 1.588px hoch, also fast zwei Bildschirme — auf JEDER
 * Seite. Den groessten Anteil haben die drei Linkgruppen (je rund 230px),
 * obwohl dort nur 1 bis 5 Links stehen.
 *
 * Das Markup nutzt bereits <details>, allerdings fest mit `open`. Statt das
 * Markup umzubauen, wird das Attribut hier je nach Bildschirmbreite gesetzt:
 * am Rechner offen wie bisher, auf dem Handy zu. Der Inhalt bleibt in beiden
 * Faellen im DOM — fuer Suchmaschinen und Screenreader aendert sich nichts.
 *
 * Der Kontaktblock bleibt bewusst immer sichtbar: Adresse und E-Mail sind
 * das, wofuer die meisten ueberhaupt in den Footer scrollen.
 */
(function () {
  'use strict';

  var GRENZE = 750;

  function anpassen() {
    var gruppen = document.querySelectorAll('.footer-block--menu .footer-block__details');
    if (!gruppen.length) return;
    var schmal = window.innerWidth < GRENZE;

    gruppen.forEach(function (gruppe) {
      // Hat jemand von Hand aufgeklappt, nicht dagegenarbeiten
      if (gruppe.dataset.welle9Angefasst === '1') return;
      if (schmal) {
        gruppe.removeAttribute('open');
      } else {
        gruppe.setAttribute('open', '');
      }
    });
  }

  function merken() {
    document.querySelectorAll('.footer-block--menu .footer-block__details').forEach(function (gruppe) {
      gruppe.addEventListener('toggle', function () {
        if (window.innerWidth < GRENZE) gruppe.dataset.welle9Angefasst = '1';
      });
    });
  }

  function start() { anpassen(); merken(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(anpassen, 150);
  });
})();
